<template>
  <v-autocomplete
    class="autoComplete"
    :disabled="showReadOnly"
    :items="items"
    density="compact"
    variant="outlined"
    :item-title="itemTitle || name || 'name'"
    :item-value="itemValue || value || 'id'"
    :placeholder="placeholder"
    :rules="rules"
    :multiple="multiple"
    v-model="localValue"
    v-model:search="searchQuery"
    @update:modelValue="onModelUpdate"
  ></v-autocomplete>
</template>

<script>
export default {
  name: "AutoComplete",
  props: {
    modelValue:  { default: null },
    items:       { type: Array,   default: () => [] },
    // Vuetify-style props (from FormBuilder)
    itemTitle:   { type: String,  default: null },
    itemValue:   { type: String,  default: null },
    // Legacy prop names
    name:        { type: String,  default: null },
    value:       { type: String,  default: null },
    placeholder: { type: String,  default: "" },
    rules:       { type: Array,   default: () => [] },
    showReadOnly:{ type: Boolean, default: false },
    multiple:    { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      searchQuery: "",
    };
  },
  computed: {
    localValue: {
      get() { return this.modelValue; },
      set(val) { this.onModelUpdate(val); },
    },
  },
  watch: {
    modelValue() {
      this.searchQuery = "";
    },
  },
  methods: {
    onModelUpdate(val) {
      this.searchQuery = "";
      this.$nextTick(() => {
        this.searchQuery = "";
      });
      this.$emit("update:modelValue", val);
      this.$emit("change", val);
    },
  },
};
</script>
